import { render, staticRenderFns } from "./AppStoreLinks.vue?vue&type=template&id=95782860"
import script from "./AppStoreLinks.vue?vue&type=script&lang=js"
export * from "./AppStoreLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports